"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var actions_1 = require("./actions");
var initState = {
    chain: { id: 0, name: '', privacy: '', terms: '', domain: '', currency: { code: '', title: '' }, country: {}, contact_details: {}, legal_details: {} },
    banners: null,
    restaurants: null,
    stripe_key: '',
    stripe_account: '',
    payment: {},
    loading: false,
};
exports.default = (function (state, action) {
    var _a, _b;
    if (state === void 0) { state = initState; }
    switch (action.type) {
        case actions_1.SET_APP_ID:
            return __assign(__assign({}, state), { chain: __assign(__assign({}, state.chain), { id: action.id }) });
        case actions_1.SET_DOMAIN:
            return __assign(__assign({}, state), { chain: __assign(__assign({}, state.chain), { domain: action.domain }) });
        case actions_1.FETCH_APP_REQUEST:
            return __assign(__assign({}, state), { loading: true });
        case actions_1.FETCH_APP_FAILURE:
            return __assign(__assign({}, state), { loading: false });
        case actions_1.FETCH_APP_SUCCESS:
            return __assign(__assign({}, state), { loading: false, chain: (_a = action.data) === null || _a === void 0 ? void 0 : _a.chain, banners: action.data.banners, restaurants: action.data.restaurants, payment: (_b = action.data) === null || _b === void 0 ? void 0 : _b.payment });
        default:
            return state;
    }
});
